var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('merchant-form',{attrs:{"merchant":_vm._merchant,"mode":"update"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var mode = ref.mode;
var errors = ref.errors;
return [_c('merchant-name-inputs',{attrs:{"mode":mode}}),_c('hr'),_c('merchant-provider-inputs',{attrs:{"mode":mode,"errors":errors}})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }